export default __webpack_public_path__ + "static/media/2091.2011bdda.png";